import React from 'react';

import styles from 'src/pages/landlord/leads/messages/LeadMessagesPage.module.css';

/**
 * Shown when the team-availability feature is on and the lead owner is away, so a
 * teammate may cover the shift by replying directly.
 */
export default function OwnerAwayNotice() {
    return (
        <div className={styles.noticeBarOuter}>
            <div className={`${styles.noticeBarInner} ${styles.noticeBarAway}`}>
                <div>
                    <div className={styles.noticeBarTitle}>Owner is away</div>
                    <div className={styles.noticeBarSubtitle}>The owner of this lead is away so you can reply directly.</div>
                </div>
            </div>
        </div>
    );
}
